export default __webpack_public_path__ + "static/media/404.d535cbd2.png";